module.exports = __webpack_public_path__ + "static/media/norte2030.47ec86b5.webp";